/* eslint-disable import/no-unresolved */
import { useSelector, useDispatch } from 'react-redux';
import { Alert as MuiAlert, IconButton, Slide } from '@mui/material';
import { Close } from '@mui/icons-material';

import { selectAlert } from '@/store/selectors';
import { closeAlert } from '@/store/slices/alert';

const Alert = () => {
  const { toggleAlert, type, message } = useSelector(selectAlert);
  const dispatch = useDispatch();

  const handleCloseAlert = () => {
    dispatch(closeAlert());
  };

  // Set a timeout after 5s, the alert should close

  if (toggleAlert) {
    setTimeout(() => {
      dispatch(closeAlert());
    }, 5000);
  }

  return (
    <Slide in={toggleAlert} mountOnEnter unmountOnExit direction="left">
      <MuiAlert
        severity={type}
        sx={{
          position: 'fixed',
          right: 50,
          top: 25,
          width: 600,
          zIndex: 1400,
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleCloseAlert}
          >
            <Close />
          </IconButton>
        }
      >
        {message}
      </MuiAlert>
    </Slide>
  );
};

export default Alert;
